export default "__VITE_ASSET__Dqlp4bw7__"